import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { FooterComponent } from './footer.component';

angular.module('app-lite.footer', [])
  .directive('worFooter', downgradeComponent({ component: FooterComponent }) as ng.IDirectiveFactory);